export const BenefitVI = {
	"benefit": {
		"headingLabel": "Quản lý phụ cấp",
		"listBenefit": "Danh sách phụ cấp",
		"createBenefit": "Thêm mới phụ cấp ",
		"updateBenefit": "Cập nhật phụ cấp "
	},
	"benefitColumns": {
		"name": "Tên phụ cấp",
		"money": "Số tiền/Đơn vị",
		"tax": "Chịu thuế",
		"status": "Trạng thái"
	},
	"benefitActions": {
		"add": "Thêm phụ cấp",
		"update": "Sửa phụ cấp"
	},
	"benefitData": {
		"positionDepartment" : "Tất cả phòng ban",
		"pending": "Không hoạt động",
		"approved": "Hoạt động",
		"reject": "Từ chối",
		"disable": "Đã vô hiệu hóa",
		"true": "Có",
		"false": "Không",
		"day": "Ngày",
		"month": "Tháng"
	},
	"benefitLabel": {
		"name": "Tên phụ cấp",
		"money": "Số tiền",
		"tax": "Chịu thuế",
		"unit": "Đơn vị"
	},
	"placeholderBenefit": {
		"name" : "Nhập tên phụ cấp ",
		"money" : "Tiền phụ cấp",
		"tax" : "Thuế",
		"unit" : "Đơn vị",
		"status" : "Trạng thái"
	}
}
